// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1lmic","left":"styles_left__2axG-"};